import Model from 'flarum/common/Model';
/**
 * A reply on a support ticket. `content` is the raw markdown source (used to
 * pre-fill the editor); `contentHtml` is the rendered output. Internal notes
 * are only visible to staff.
 */
export default class SupportReply extends Model {
  content = (() => Model.attribute('content'))();
  contentHtml = (() => Model.attribute('contentHtml'))();
  isInternalNote = (() => Model.attribute('isInternalNote'))();
  canEdit = (() => Model.attribute('canEdit'))();
  canDelete = (() => Model.attribute('canDelete'))();
  isDeleted = (() => Model.attribute('isDeleted'))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
  updatedAt = (() => Model.attribute('updatedAt', Model.transformDate))();
  editedAt = (() => Model.attribute('editedAt', Model.transformDate))();
  deletedAt = (() => Model.attribute('deletedAt', Model.transformDate))();
  user = (() => Model.hasOne('user'))();
  editedBy = (() => Model.hasOne('editedBy'))();
  ticket = (() => Model.hasOne('ticket'))();
}
flarum.reg.add('linkrobins-support', 'common/models/SupportReply', SupportReply);